import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import store from '../../redux/index'
import { setToken, setUserInfo } from '../../redux/actions/basic'
import { history } from '../../router/index'
import { Toast } from 'antd-mobile'

export interface UploadRes {
  filename: string
  id: string
  url: string
}

const instance: AxiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  },
  timeout: 1000 * 120
})

instance.interceptors.request.use(function (config) {
  // config.url = `/api${config.url}`;
  return config
})

type instanceType = 'get' | 'delete' | 'post' | 'put'

interface Response {
  message: string
  data: any
  status: number
}

type RequestFn = (url: string, data?: any, config?: AxiosRequestConfig) => Promise<Response>

/**
 * 请求方法
 * @param {*} type 请求类型
 */
function request (type: instanceType, isAuth: boolean): RequestFn {
  return async function (url: string, data: any = {}, config: AxiosRequestConfig = {}): Promise<Response> {
    const { basic } = store.getState()
    const { token, userInfo } = basic
    const option = {
      url,
      method: type,
      ...config
    }
    if (isAuth) {
      option.headers = {
        Authorization: `Bearer ${token}`
      }
      data.uid = userInfo.id
    }
    if (type === 'get' || type === 'delete') {
      option.params = data
    } else {
      option.data = data
    }
    return await new Promise((resolve, reject) => {
      instance(option).then((res) => {
        const d = res.data
        if (d.status !== 1) {
          Toast.show({
            content: d.message,
            icon: 'fail',
            duration: 1500
          })
          reject(new Error(d.message))
        } else {
          resolve(d)
        }
      }).catch((e) => {
        const { basic } = store.getState()
        const { status, data } = e.response
        if (basic.token === '') {
          if (history.location.pathname !== '/login') {
            history.push('/login')
          }
          return reject(e)
        }
        if (status === 401 || (status === 500 && data.message === '登录超时')) {
          Toast.show({
            content: token !== '' ? '登录超时' : '请先登录',
            icon: 'fail',
            duration: 1500
          }) as never
          store.dispatch(setToken(''))
          store.dispatch(setUserInfo({
            app_default: '',
            desktop: '',
            employeeid: '',
            id: '',
            is_auth: 0,
            mobile: '',
            realname: '',
            role_default: ''
          }))
          history.push('/login')
        } else if (status === 504) {
          Toast.show({
            content: '网络异常',
            icon: 'fail',
            duration: 1500
          })
        } else {
          Toast.show({
            content: data.message,
            icon: 'fail',
            duration: 1500
          })
        }
        reject(e)
      })
    })
  }
}

// 需要鉴权的请求
export const $get: RequestFn = request('get', true)
export const $delete: RequestFn = request('delete', true)
export const $post: RequestFn = request('post', true)
export const $put: RequestFn = request('put', true)

// 不需要鉴权的请求
export const $freeGet: RequestFn = request('get', false)
export const $freeDelete: RequestFn = request('delete', false)
export const $freePost: RequestFn = request('post', false)
export const $freePut: RequestFn = request('put', false)

// 上传单个文件请求
export const requestOneFile = async function (file: File): Promise<Response> {
  const state = store.getState()
  const { token } = state.basic
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`
    }
  }
  const formData = new FormData()
  formData.append('upload_file', file)
  formData.append('uid', state.basic.userInfo.id)
  return await $post('/api/common/vupload', formData, config)
}

// 上传多个文件请求
export const requestFiles = async function (files: File[]): Promise<UploadRes[]> {
  const list = files.map(requestOneFile)
  const resList = await Promise.all(list)
  const result: UploadRes[] = []
  resList.forEach(res => {
    if (res.status === 200 && res.data.status === 1) {
      result.push(res.data.data)
    } else {
      throw new Error('上传文件失败')
    }
  })
  return result
}
